
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL2 = runEvn().api2BaseUrl;
const baseURL = runEvn().apiBaseUrl;

 
 
//前端列表分页查询
export const getActivity = (data: any): Promise<any> => {
    return axios.get(`${baseURL2}/user/Activity`, { params: data })
}

//前端列表分页查询
export const getActivityDetail = (id: string): any => {
    return axios.get(`${baseURL2}/user/Activity/${id}`)
}
export const postSignUp = (data): Promise<any> => {
    return axios.post(`${baseURL2}/user/ActivityEnroll`, data);
}
 
//预约活动 取消报名
export const postCancel = (data): Promise<any> => {
    return axios.post(`${baseURL2}/user/ActivityEnroll/Cancel`, data);
}
 